import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API()+'przystanki/';

export default {

    getPrzystanki() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    getPrzystanek(id) {
        return axios({
            method: 'get',
            url: URL+id,
        });
    },

    addPrzystanek(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editPrzystanek(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deletePrzystanek(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/przystanki/PrzystankiService.js